import type { AlertProps } from '@mui/material';
import { IconButton } from '@mui/material';
import { CrossIcon } from '@tix-ticketing/ui-icons/outline';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
export function showToast({
  title,
  message,
  severity,
  duration = 6000,
  persist
}: {
  title: string;
  message: string;
  severity: AlertProps['severity'];
  duration?: number;
  persist?: boolean;
}) {
  const id = enqueueSnackbar(message, {
    variant: 'toast',
    persist: persist ?? false,
    autoHideDuration: persist ? null : duration,
    alertProps: {
      title: title,
      severity: severity ?? 'info',
      icon: false,
      sx: {
        maxWidth: 480
      },
      action: <IconButton onClick={() => {
        closeSnackbar(id);
      }} aria-label="Close" sx={{
        padding: '4px',
        '& svg': {
          fontSize: '16px',
          width: '16px',
          height: '16px'
        }
      }}>
          <CrossIcon />
        </IconButton>
    }
  });
  return id;
}